import type { MatchHubResultLabel } from '../../../src/match/types/matchHub.types';

export function formatShortMd(iso: string): string {
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    return `${d.getMonth() + 1}/${d.getDate()}`;
  } catch {
    return '';
  }
}

export function resultLabelShort(resultLabel: MatchHubResultLabel | undefined): string {
  if (resultLabel === 'AET') return 'After extra time';
  if (resultLabel === 'PEN') return 'Penalties';
  return 'Final';
}
